import { ValidationErrors, ValidatorFn } from '@angular/forms';

export function prepaidLimit(value: boolean): ValidatorFn {
    return (): ValidationErrors | null => {
        return { prepaidLimit: value };
    };
}
